/**
 * Correção para problema de NaN no carrinho
 * Este arquivo corrige problemas de formatação de dinheiro que podem causar NaN
 */

(function() {
  'use strict';
  
  // Função para validar e corrigir valores monetários
  function validateMoneyValue(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) {
      return 0;
    }
    
    const numericValue = typeof value === 'string' ? parseFloat(value) : value;
    return isNaN(numericValue) ? 0 : Math.max(0, numericValue);
  }
  
  // Função para formatar dinheiro de forma segura
  function safeFormatMoney(cents, format) {
    const validatedCents = validateMoneyValue(cents);
    
    // Tenta usar a função do tema se disponível
    if (typeof Currency !== 'undefined' && Currency.formatMoney && format) {
      try {
        return Currency.formatMoney(validatedCents, format);
      } catch (e) {
        console.warn('Erro na formatação do tema, usando fallback:', e);
      }
    }
    
    // Fallback para formatação brasileira
    const value = validatedCents / 100;
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  }
  
  // Intercepta e corrige elementos que podem mostrar NaN
  function fixNaNInElements() {
    // Procura por elementos que podem conter NaN
    const selectors = [
      '[data-money-convertible]',
      '.price',
      '.cart-recap__price-line-price',
      '.line-item__price',
      '.mini-cart__price-list',
      '[data-line-item-price]'
    ];
    
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        if (element.textContent && element.textContent.includes('NaN')) {
          console.warn('NaN encontrado em elemento, corrigindo:', element);
          element.textContent = 'R$ 0,00';
        }
      });
    });
  }
  
  // Intercepta chamadas para Currency.formatMoney
  if (typeof Currency !== 'undefined' && Currency.formatMoney) {
    const originalFormatMoney = Currency.formatMoney;
    Currency.formatMoney = function(cents, format) {
      const validatedCents = validateMoneyValue(cents);
      return originalFormatMoney.call(this, validatedCents, format);
    };
  }
  
  // Observer para detectar mudanças no DOM
  const observer = new MutationObserver(function(mutations) {
    let shouldCheck = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        shouldCheck = true;
      }
    });
    
    if (shouldCheck) {
      setTimeout(fixNaNInElements, 100);
    }
  });
  
  // Inicia o observer quando o DOM estiver pronto
  function init() {
    fixNaNInElements();
    
    // Observa mudanças no carrinho e mini-cart
    const cartElements = document.querySelectorAll('#mini-cart, .cart-wrapper, .line-item-table');
    cartElements.forEach(element => {
      observer.observe(element, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
    
    // Verifica periodicamente por NaN
    setInterval(fixNaNInElements, 5000);
  }
  
  // Executa quando o DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Intercepta eventos de carrinho
  document.addEventListener('cart:refresh', function() {
    setTimeout(fixNaNInElements, 200);
  });
  
  document.addEventListener('product:added', function() {
    setTimeout(fixNaNInElements, 200);
  });
  
  // Expõe funções para debug
  window.fixCartNaN = {
    validateMoneyValue: validateMoneyValue,
    safeFormatMoney: safeFormatMoney,
    fixNaNInElements: fixNaNInElements
  };
  
})();